import { Treatment } from '@next/arable-lib/advice';
import { Crop } from '@next/arable-lib/crop';
import { CropField } from '@next/arable-lib/crop-field';

export interface CropFieldWrapper {
  cropField: CropField;
  crop: Crop;
  cropFieldName: string;
  fertilizationTreatments: Treatment[];
  gbmTreatments: Treatment[];
  numberOfGbmTreatments: number;
  numberOfFertilizationTreatments: number;
  isAutomaticFertilizationAdvice?: boolean;
  cropVarietyEdiCode?: number;
}

export const CORN_AGRIFIRM_CROP_IDS: number[] = [
  1035, // CCM/korrelmais
  1036, // Snijmais
  1135, // Suikermais
];

export const SUIKERBIET_AGRIFIRM_CROP_ID = 1009;
export const SUIKERBIET_WARNING_EDICROP_IDS: number[] = [
  20530, // BTS Smart 1645 N
  20751, // BTS Smart 3905 RHC
  20902, // BTS Smart 4825
  20862, // BTS Smart 6655 N
  20657, // BTS Smart 6745
  20531, // BTS Smart 9135
  20903, // BTS Smart 9775
  20863, // Smart Blomma KWS
  21010, // Smart Enissa KWS
  20429, // Smart Imma KWS
  21009, // Smart Justina KWS
  20535, // Smart Latoria KWS
  20430, // Smart Liesa KWS
  20916, // Smart Manja KWS
  20915, // Smart Mirea KWS
  20536, // Smart Pea KWS
  20431, // Smart Tomma KWS
];


export const CICHOREI_AGRIFIRM_CROP_ID = 1085;
export const CICHOREI_WARNING_EDICROP_IDS: number[] = [
  19867, // Barite
  19811, // Benulite
  20960, // Damona
  20686, // Dunite
  20687, // Orenda
  20688, // Petalite
  20961, // Pyrolusite
  20258, // Rhodonite
  20526, // Soupir
];
